import { Container } from "../../Container/Container";
import { FlexContainer } from "../../Container/FlexContainer";
import { Div } from "../../Div";
import { Input as FormInput } from "../../Form/Input";

export class SearchBox extends Container {
    protected createSelf() {
        const has: Container = new FlexContainer({className: "hasbox"});
        const hai: Container = new FlexContainer({className: "haibox"});
        const input = new FormInput({
            attributes: [
                {n: "placeholder", v: "affiner la liste..."},
                {n: "type", v: "search"},
            ],
            class: "searchbox",
        });

        input.addListener("keyup", (event: any) => { this.change(event); });
        input.addListener("search", (event: any) => { this.change(event); });

        this.addToData("itag", input);

        hai.appendChild(new Div({
            c: [{t: "t", tag: input}],
            className: "haic",
        }));
        hai.appendChild(new Div({
            onClick: (event: any) => { this.change(event, true); },
            html: "<div class=\"halense\">\n" +
                  "             <button class=\"hablense\">\n" +
                  "                 <svg focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n" +
                  "                     <path d=\"M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"></path>\n" +
                  "                 </svg>\n" +
                  "             </button>\n" +
                  "         </div>",
        }));
        has.appendChild(hai);
        this.setElement(has.getElement());
    }

    public getValue() {
        return this.get("itag").getText();
    }

    protected change(event: any, force?: boolean) {
        if (force || event.keyCode === 13 || event.type === "search") {
            const f = this.get("kup");
            if (f) { f(this.getValue()); }
        }
    }
}
